import draftIcon from "../../assets/images/draft_icon.png";
import reviewIcon from "../../assets/images/review_icon.png";
import publishedIcon from "../../assets/images/published_icon.png";
import rejectedIcon from "../../assets/images/rejected_icon.png";
import mergedIcon from "../../assets/images/merged_icon_default.svg";
import disabledIcon from "../../assets/images/disabled_icon.png";
import IconWithHover from "../IconButtons/IconWithHover/IconWithHover";
import React, {useEffect, useState} from "react";
import Button from "react-bootstrap/Button";
import axios from "axios";
import apiUrl from "../../shared/config";
import Spinner from "react-bootstrap/Spinner";

const unapprovedMerge = 'Merge Awaiting Approval';
const approvedMerge = 'Approved Merge';

export default function PatternStateIcon({hasMerged, patternStateName, pattern_id = null, token = null, isAuthor = false, reloadPattern = () => {}}) {
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        setIsLoading(false)
    }, [pattern_id, token]);

    let state_image = "";
    let state_title = hasMerged ? (+hasMerged === 1 ? unapprovedMerge : approvedMerge) : patternStateName;
    let state_desc = "";
    let mergeBorder = "orange"
    switch (state_title) {
        case "Draft":
            state_image = (
                <img className="state-icon Draft align-self-right" src={draftIcon} alt="Draft"/>);
            state_desc = 'This pattern can only be viewed by pattern authors';
            break;
        case "Review":
            state_image = (<img className="state-icon Review" src={reviewIcon} alt="In Review"/>);
            state_desc = <>This pattern can be viewed by pattern authors <br/>and members of the pattern's groups</>;
            break;
        case "Published":
            state_image = (<img className="state-icon Published" src={publishedIcon} alt="Published"/>);
            state_desc = "This pattern can be viewed by the general public";
            break;
        case "Rejected":
            state_image = (<img className="state-icon Rejected" src={rejectedIcon} alt="Rejected"/>);
            state_desc = 'This pattern can only be viewed by pattern authors'; //TODO: double check that this is right
            break;
        case approvedMerge:
            mergeBorder = "#a1a1a1";
        // intentional missing break
        // eslint-disable-next-line no-fallthrough
        case unapprovedMerge:
            state_image = (<img className="state-icon Merged" src={mergedIcon} alt="Merged"
                                style={{
                                    borderStyle: 'solid',
                                    borderWidth: '2px',
                                    borderColor: mergeBorder,
                                }}/>);
            break;
        case "Disabled":
            state_image = (<img className="state-icon Disabled" src={disabledIcon} alt="Disabled"/>);
            state_desc = 'This pattern can only be viewed by pattern authors';
            break;
        default:
            state_image = (<img className="state-icon Disabled" src={disabledIcon} alt="Disabled"/>);
            state_desc = 'This pattern can only be viewed by pattern authors';
            break;
    }

    function setMergeState(flag) {
        if (!isLoading) {
            setIsLoading(true)
            axios.get(apiUrl + `Pattern/setMergeFlag?pattern_id=${pattern_id}&token=${token}&merge_flag=${flag}`)
                .then(_ => {
                    setIsLoading(false)
                    //refresh
                    reloadPattern();
                }).catch(error => {
                console.log('Failed to set merge state flag:', error?.message)
                setIsLoading(false)
            })
        }
    }

    const stateEditor = <div style={{maxWidth: 500, width: '100%', fontStyle: "normal", color: "black", marginTop: 5}}
                             className={'informational-list-container'}>
        <ul className={'informational-list'}>
            <li>Your pattern has been merged with another pattern. Please review the merged pattern(s) in the dedicated section at bottom of the page.
            </li>
            <li>If you approve this merge your pattern will:
                <ul>
                    <li className={'unset-list'}>
                        Remain visible to you and other authors, but will not show up in the search unless the search is
                        by pattern name.
                    </li>
                    <li className={'unset-list'}>
                        Still be accessible through a direct links.
                    </li>
                    <li className={'unset-list'}>
                        Copy its positive and negative ratings to the new pattern.
                    </li>
                </ul>
            </li>
            <li>If you disapprove of this merge your pattern it will return to its previous pattern state.</li>
        </ul>
        <div style={{
            paddingTop: 25,
            float: "right",
            paddingBottom: 15
        }}>
            {isLoading &&
                <Spinner animation={'border'} style={{width: 30, height: 30, marginBottom: -10, marginRight: 10}}/>}
            <Button className={'preset-modal-button-button'} onClick={() => setMergeState(2)}>Approve</Button>
            <Button className={'preset-modal-cancel-button'} onClick={() => setMergeState(0)}
                    style={{marginLeft: 10}}>Disapprove</Button>
        </div>

    </div>

    const switchMergeStateDescription = state_title === unapprovedMerge ?
        (isAuthor ? stateEditor : <div style={{maxWidth: 300}}>Waiting for a pattern author to approve this merge.</div>)
        :
        <div style={{maxWidth: 300}}>One of the authors of this pattern has approved a merge with another pattern in the
            library.
            To view the pattern this pattern has been merged into scroll to the patterns section at the bottom of this
            pattern's display.</div>

    return (
        <IconWithHover icon={state_image}
                       popoverContent={{
                           title: <b style={state_title === unapprovedMerge && isAuthor ? {fontSize: 20} : {}}>{state_title}</b>,
                           text: hasMerged ? switchMergeStateDescription : state_desc
                       }}
                       direction={state_title === unapprovedMerge && isAuthor ? 'right-start' : 'bottom'}
        />
    )
}